import { render, staticRenderFns } from "./IPTVWebplayerLayout.vue?vue&type=template&id=faa49e56"
import script from "./IPTVWebplayerLayout.vue?vue&type=script&lang=ts"
export * from "./IPTVWebplayerLayout.vue?vue&type=script&lang=ts"
import style0 from "./IPTVWebplayerLayout.vue?vue&type=style&index=0&id=faa49e56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports